var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"left",on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('span',[_vm._v("返回")])])]),_c('div',{staticClass:"page-header-pla"})])
}
var staticRenderFns = []

export { render, staticRenderFns }